// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link[data-v-12d6aeca] {\n  color: var(--magic-tertiary, #311261);\n}\n.link[data-v-12d6aeca]:hover, .link[data-v-12d6aeca]:focus, .link.is-active[data-v-12d6aeca] {\n  --magic-font-weight-semibold: 700;\n}", ""]);
// Exports
module.exports = exports;
